import { render } from "./ImgGroup.vue?vue&type=template&id=8403f336&scoped=true"
import script from "./ImgGroup.vue?vue&type=script&lang=js"
export * from "./ImgGroup.vue?vue&type=script&lang=js"

import "./ImgGroup.vue?vue&type=style&index=0&id=8403f336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8403f336"]])

export default __exports__